import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_bottom_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M15 4H9v11h6V4zM4 18.5V20h16v-1.5H4z" }) });
export {
  justify_bottom_default as default
};
//# sourceMappingURL=justify-bottom.js.map
